"use client";
import styled from "../../../../client-utils/styled/index.js";
import shouldForwardProp from "../../../../client-utils/styled/shouldForwardProp.util.js";
import { SINGLE } from "../../../../constants/numbers.consts.js";
import { coreComponentName } from "../SearchBar.consts.js";
import InputAdornmentAtom from "../../../../components/atoms/InputAdornment/index.js";
import PrintModifierKeyAtom from "../../../../components/atoms/PrintModifierKey/index.js";
export const InputAdornment = styled(InputAdornmentAtom, {
    name: coreComponentName,
    slot: "InputAdornment",
})({ gap: 12 });
export const PrintModifierKey = styled(PrintModifierKeyAtom, {
    name: coreComponentName,
    slot: "ModifierKey",
    shouldForwardProp: shouldForwardProp("open"),
})(({ open, theme }) => ({
    opacity: open ? SINGLE : 0,
    width: open ? "content-fit" : 0,
    transition: `width 0.2s ${open ? "step-end" : "step-start"}, ${theme.transitions.create("opacity", { duration: theme.transitions.duration.complex })}`,
}));
